import styled from "styled-components";

export const Wrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.headerBg, //transparent
  color: theme.palette.white,
  flexShrink: 0,
}));
